<script>
  // @ts-check
  import {
    getBreakpointAdjustedFields,
    getHeroGroupEntryVariant,
    getHeroVariantProps,
    HERO_VARIANTS,
    HERO_VARIANTS_WITH_THEME
  } from "$lib/utilities/contentTypes/hero";
  import { HeroGroup } from "@ObamaFoundation/of-design-system";
  import { heroThemeStore, heroFormFactorStore } from "$lib/stores";
  import { getContext, afterUpdate } from "svelte";
  // eslint-disable-next-line @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  import { BREAK_POINTS } from "$lib/utilities/constants";

  export let data;

  const pageDataContext = getContext("pageData");

  let screenWidth = 0;

  let currentIndex = 0;

  $: entries = data.fields.items.map((item) => {
    const variant = getHeroGroupEntryVariant(item.fields?.formFactor);

    const breakpointAdjustedFields = getBreakpointAdjustedFields(item.fields, screenWidth);

    const heroProps = getHeroVariantProps(
      breakpointAdjustedFields,
      pageDataContext,
      $page?.url?.pathname
    );

    return { variant, ...heroProps };
  });

  function updateThemeStore(hero) {
    if (!hero) {
      return;
    }

    const hasThemedBackground = HERO_VARIANTS_WITH_THEME.includes(hero.formFactor);

    if (
      hero.formFactor === HERO_VARIANTS.PRIMARY_BACKGROUND_MEDIA ||
      (hero.formFactor === HERO_VARIANTS.HOMEPAGE_BACKGROUND_MEDIA &&
        screenWidth >= BREAK_POINTS.lg)
    ) {
      heroThemeStore.set("black");
    } else if (hasThemedBackground) {
      // Used to update the the Global Navigation background color based on current Home Hero background color
      heroThemeStore.set(hero.theme ?? "white");
      heroFormFactorStore.set(hero.formFactor ?? "");
    } else {
      heroThemeStore.set("white");
    }
  }

  afterUpdate(() => {
    updateThemeStore(entries[currentIndex]);
  });
</script>

<svelte:window bind:innerWidth={screenWidth} />

<div class="-mt-[var(--nav-height)] mb-10 md:mb-15 lg:mb-20 xl:mb-25">
  <HeroGroup {entries} bind:currentIndex />
</div>
